define('components/factory/models/MultiItemsModel', [

], function() {

    var MultiItemsModel = Backbone.Model.extend({
        defaults: {
            viewId: "someId",           // Classic default viewId
            moreItemToLoad: false,      // Show / hide the more-item button
            lineWeight: 3,              // The number of column in a line
            maxLinesToShow: 1,          // The number of lines shown first
            maxLinesToAdd: 1,           // The number of lines added on click on more-item button
            items: [],                  // All items shown first
            pendingItems: [],           // The items to add on click on more-item button
            isReady: false              // Classic isReady
        }
    });

    return MultiItemsModel;
});
